import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';

import { UIDataModel, UIComponentState } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { SearchlistCSSStyle } from './searchlistcss';
import { PaginationVerticalListComponent } from '../../../../toolkit/verticallist/paginationverticallist/paginationverticallistcomponent';
import { SearchlistComponentProps, SearchlistComponentHandler } from './searchlistcomponent';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';

export class SearchlistViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private paginationListRef: PaginationVerticalListComponent<ToneDto> | null;

    draw(props: SearchlistComponentProps, state: UIComponentState, cssStyle: SearchlistCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
              <PaginationVerticalListComponent ref={(item: any) => {this.paginationListRef = item;}} onLoadMore={(this.getUIComponentHandler() as SearchlistComponentHandler).onLoadMore} listViewModel={props.listViewModel} context={props.context}/>
        );
    }

    updatePaginationCount()
    {
        this.paginationListRef !== null && this.paginationListRef.updatePaginationCount();
    }

    resetPaginationCount()
    {
        this.paginationListRef !== null && this.paginationListRef.resetPaginationCount();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/playlist/searchlistview.tsx